import { toast } from "react-toastify";
import { callApi } from "../api/apiCaller";
import routes from "../api/routes";

export const GreenNotify = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};

export const RedNotify = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};

export const uploadMediaToS3 = async (files, isMultiple = false) => {
  const fileList = isMultiple ? Array.from(files) : [files];

  // Step 1: Prepare payload for backend to get signed URLs
  const payload = fileList.map((file) => ({
    name: file.name || `upload_${Date.now()}`,
    type: file.type,
  }));

  // Step 2: Get signed URLs from backend

  const signedUrls = await new Promise((resolve, reject) => {
    callApi(
      "POST",
      routes.upload,
      { files: payload },
      undefined,
      (res) => resolve(res?.urls),
      (err) => {
        console.error("Failed to get signed URLs:", err);
        reject(err);
      }
    );
  });

  // Step 3: Upload files to S3 using signed URLs (PUT)
  const uploadPromises = signedUrls.map(async (urlObj, index) => {
    const file = fileList[index];

    try {
      const uploadRes = await fetch(urlObj.uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
          "Content-Disposition": `inline;filename="${encodeURIComponent(
            urlObj.name
          )}"`,
        },
        body: file,
      });

      if (!uploadRes.ok) {
        throw new Error(`Upload failed for ${urlObj.name}`);
      }

      return urlObj.fileUrl;
    } catch (uploadError) {
      console.error(`Upload error for ${urlObj.name}:`, uploadError);
      throw uploadError;
    }
  });

  const uploadedUrls = await Promise.all(uploadPromises);
  return isMultiple ? uploadedUrls : uploadedUrls[0];
};
